import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-ranking-panel',
  templateUrl: './ranking-panel.component.html',
  styleUrl: './ranking-panel.component.scss',
  standalone: false
})
export class RankingPanelComponent {

  @Input() overallRank: string | number | undefined;
  @Input() sexRank: string | number | undefined;
  @Input() sex: number | undefined;
  @Input() categoryRank: string | number | undefined;
  @Input() cssClass: string = "";
}
